import { CommandBar, DefaultButton, DetailsHeader, DetailsList, DetailsListLayoutMode, DetailsRow, Dialog, DialogFooter, DialogType, IButtonProps, IColumn, ICommandBarItemProps, ICommandBarStyles, IconButton, IDetailsListProps, IDetailsListStyles, IDetailsRowStyles, IDialogContentProps, ITextField, ITextFieldProps, ITextFieldStyleProps, ITooltipHostStyles, Label, mergeStyleSets, PrimaryButton, Text, TextField, TooltipHost, updateRGB } from '@fluentui/react';
import React from 'react'
import { connect, ConnectedProps } from 'react-redux';
import { Prompt, RouteComponentProps } from 'react-router-dom';
import { Unsubscribe } from 'redux';
import { checkRoles } from '../../../hoc/CheckRoles';
import { RoleContext } from '../../../shared/enums';
import { IArxeiaConfiguration } from '../../../shared/interfaces';
import { reduxActions, RootState } from '../../../store';
import abilityBuild from '../../../shared/CASL/appAbility';
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import CustomCommandBarButton, { CustomCommandBarButtonProps } from '../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import { myTheme } from '../../../assets/styles/my-theme';
import { SessionState } from '../../../store/session/types';
import arxeiaConfigurationsService from '../../../services/arxeiaConfigurations.service';
import { toastRef } from '../../Layout/Layout';

const editIcon = { iconName: 'Edit' };
const acceptIcon = { iconName: 'Accept' };
const cancelIcon = { iconName: 'Cancel' };
const { palette } = myTheme;

const extendedTextFieldStyles = {
    width: '100%'
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};
const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        '& .ms-DetailsRow-cell': {
            display: "flex",
            flexFlow: "column",
            justifyContent: "center"
        }
    }
};

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
})

const mapDispatch = {
    updateSession: (newSessionState: Partial<SessionState>) => (reduxActions.sessionActions.updateSession(newSessionState))
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface ConfigurationsManagerProps {

}

type Props = ConfigurationsManagerProps & RouteComponentProps & PropsFromRedux;

export interface ConfigurationsManagerState {
    commandBarItems: ICommandBarItemProps[]
    columns: IColumn[]
    items: any[]
    textFieldIsOpen: boolean
    changesMade: boolean
    changesSaved: boolean
    isEnabled: boolean
    confirmDialogIsOpen: boolean
    confirmDialogContentProps: IDialogContentProps
    confirmDialogSubmitFunction: Function
}
class ConfigurationsManager extends React.Component<Props, ConfigurationsManagerState> {
    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };
    textFieldRef = React.createRef<ITextField>();
    constructor(props) {
        super(props);
        this.state = {
            commandBarItems: [
                {
                    key: 'saveChanges',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            asDefaultButton={true}
                            text='Salva'
                            key='saveChanges'
                            disabled={!this.state.isEnabled}
                            iconPropsFontAwesome={{ icon: ['fa-regular', 'fa-check'] }}
                            onClick={this.saveChangesHandler}
                        />
                    )
                }
            ],
            columns: [
                {
                    key: 'span',
                    name: '',
                    fieldName: 'span',
                    minWidth: 16,
                    maxWidth: 16,
                    onRender: (item) => {
                        if (item) {
                            return <span></span>
                        }
                    }
                },
                {
                    key: 'name',
                    name: 'Nome',
                    fieldName: 'name',
                    minWidth: 100,
                    maxWidth: 800,
                    isResizable: true,
                    isMultiline: true,
                    onRender: (item) => {
                        return <>
                            <div style={{ fontSize: 'medium' }}>{item.name}</div>
                            <div>{item.description}</div>
                        </>
                    }
                },
                {
                    key: 'icon',
                    name: '',
                    iconName: '',
                    fieldName: '',
                    minWidth: 60,
                    maxWidth: 60,
                    onRender: (item) => {
                        if (item.isEdit) {
                            return (
                                <div className="my-icons-accept-cancel" >
                                    <IconButton
                                        iconProps={acceptIcon}
                                        disabled={!this.state.changesMade}
                                        onMouseDown={() => this.handleIconButtonAcceptClick(item)}
                                    />
                                    <IconButton
                                        iconProps={cancelIcon}
                                        disabled={false}
                                        onMouseDown={() => this.handleIconButtonCancelClick(item)}
                                    />
                                </div>
                            );
                        } else {
                            return (
                                <div className="my-icon-edit" >
                                    < TooltipHost
                                        content="Clicca qui per inserire il valore"
                                        id={""}
                                    >
                                        <IconButton
                                            iconProps={editIcon}
                                            disabled={false}
                                            onClick={() => this.handleIconButtonEditClick(item)}
                                        />
                                    </TooltipHost >
                                </div>
                            );
                        }
                    }
                },
                {
                    key: 'input',
                    name: 'Valore',
                    minWidth: 200,
                    isResizable: true,
                    onRender: (item) => {
                        if (item.isEdit) {
                            return <TextField
                                label={""}
                                placeholder={"-"}
                                borderless={true}
                                componentRef={this.textFieldRef}
                                value={item.value}
                                onChange={(event, newValue) => this.handleTextFieldChange(event, item, newValue)}
                                onKeyDown={(event) => this.handleEscKeyPress(event, item)}
                                onBlur={() => this.handleIconButtonCancelClick(item)}
                                styles={{ root: extendedTextFieldStyles }}

                            />
                        } else {
                            return (
                                <span className="text-overflow-ellipsis">{item.value}</span>
                            )
                        }
                    }

                },
                /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                /// l'header e i contenuti della tabella 
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },
            ],

            items: [],
            textFieldIsOpen: false,
            changesMade: false,
            changesSaved: false,
            isEnabled: false,
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
        }
    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('read', 'IArxeiaConfiguration')) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
        });
        if (this.props.arxeiaConfigurations) {
            this.remapArxeiaConfigurations();
        }
        if (this.textFieldRef.current) {
            this.textFieldRef.current.focus();
            this.textFieldRef.current.select();
        }
    }

    componentDidUpdate(oldProps: Props, oldState: ConfigurationsManagerState) {

        if (oldProps.arxeiaConfigurations !== this.props.arxeiaConfigurations && this.props.arxeiaConfigurations) {
            this.remapArxeiaConfigurations();
        }
        if (oldState.textFieldIsOpen !== this.state.textFieldIsOpen && this.textFieldRef.current) {
            this.textFieldRef.current.focus();
            this.textFieldRef.current.select();
        }
        // previene il refresh e la chiusura del tab senza salvare
        window.onbeforeunload = (event) => {
            const e = event || window.event;
            e.preventDefault();
            if (e) {
                e.returnValue = true;
            }
            return true;
        };
    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
        window.onbeforeunload = null;
    }

    getArxeiaConfigurations() {
        arxeiaConfigurationsService.getArxeiaConfigurations()
            .then(configurations => {
                this.props.updateSession({ arxeiaConfigurations: configurations });
            });
    }

    remapArxeiaConfigurations() {
        let configArray: IArxeiaConfiguration[] = [];
        this.props.arxeiaConfigurations!.map(config => {
            if (config.show) {
                configArray.push(config);
            }
            return configArray;
        });
        this.setState({ items: configArray });
    }

    //modifico il valore
    handleIconButtonEditClick = (item: any) => {
        const { items } = this.state;
        const updatedItems = [...items];

        //trovo l'indice dell'item modificato
        const itemIndex = updatedItems.findIndex(i => i === item);
        if (itemIndex !== -1) {
            //aggiorno l'item a edit e salvo il valore originale
            updatedItems[itemIndex] = {
                ...item,
                isEdit: true,
                originalValue: item.value
            };
        }
        // aggiorno lo stato    
        this.setState({ items: updatedItems, changesMade: false, textFieldIsOpen: true })
    }

    //gestisco l'input della textfield
    handleTextFieldChange = (ev: any, item: any, newValue?: string) => {
        const { items } = this.state;
        const updatedItems = [...items];

        //trovo l'indice dell'item modificato
        const itemIndex = updatedItems.findIndex(i => i === item);
        if (itemIndex !== -1) {
            //aggiorno l'item con il nuovo valore e a touched
            updatedItems[itemIndex] = {
                ...item,
                value: newValue!,
                isTouched: true
            };
        }
        // aggiorno lo stato    
        this.setState({ items: updatedItems, isEnabled: true, changesMade: true, textFieldIsOpen: true })
    }

    // confermo la modifica 
    handleIconButtonAcceptClick = (item: any) => {
        const { items } = this.state;
        const updatedItems = [...items];

        //trovo l'indice dell'item modificato
        const itemIndex = updatedItems.findIndex(i => i === item);
        if (itemIndex !== -1) {
            //aggiorno l'item e chiudo la textField
            updatedItems[itemIndex] = {
                ...item,
                isEdit: false,
                isTouched: true
            };
        }
        // aggiorno lo stato    
        this.setState({ items: updatedItems, isEnabled: true, changesMade: true, changesSaved: false, textFieldIsOpen: false })
    }

    //cancello la modifica
    handleIconButtonCancelClick = (item: any) => {
        const { items } = this.state;
        const updatedItems = [...items];

        //trovo l'indice dell'item modificato
        const itemIndex = updatedItems.findIndex(i => i === item);
        if (itemIndex !== -1) {
            //aggiorno l'item e recupero il valore originale che sovrascrive eventuali modifiche nella textField
            updatedItems[itemIndex] = {
                ...item,
                isEdit: false,
                isTouched: false,
                value: item.originalValue
            };
        }
        this.setState({ items: updatedItems, textFieldIsOpen: false, changesMade: false }, this.isEnabledIfIsTouched)
    }

    // metodo per chiudere textField con Esc
    handleEscKeyPress = (event: any, item: any) => {
        if (event.key === 'Escape') {
            this.handleIconButtonCancelClick(item);
        }
    };

    // metodo per controllo Salva enabled/disabled
    isEnabledIfIsTouched = () => {
        const { items } = this.state;
        const isAnyItemTouched = items.some((item) => item.isTouched);

        if (isAnyItemTouched) {
            this.setState({ isEnabled: true });
        } else {
            this.setState({ isEnabled: false });
        }
    }

    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    onRenderItemRow: IDetailsListProps['onRenderRow'] = (props) => {
        const customStyles: Partial<IDetailsRowStyles> = {};
        const { item } = props!;
        if (item.isTouched) {
            customStyles.root = {
                '& .ms-DetailsRow-cell:first-child': {
                    borderRight: 'solid',
                    borderColor: `${palette.themePrimary} `
                }
            }
        }
        return <DetailsRow {...props!} styles={customStyles} />;
    }

    // Metodi per la gestione del salva:
    // Click sul salva della commandbar
    saveChangesHandler = () => {
        let configsChanged: any[] = [...this.state.items];
        let touchedItems = configsChanged.filter(item => item.isTouched === true);

        this.setState(
            {
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Chiudi',
                    subText: 'Vuoi salvare le modifiche?'
                },
                confirmDialogSubmitFunction: () => { this.saveChangesConfirmDialogSubmit(touchedItems) }
            }
        )
    }
    // Click su conferma del confirm dialog
    saveChangesConfirmDialogSubmit = (configsChanged: IArxeiaConfiguration[]) => {
        if (this.props.arxeiaConfigurations && configsChanged) {
            arxeiaConfigurationsService.updateArxeiaConfigurations(configsChanged)
                .then(result => {
                    this.getArxeiaConfigurations();
                    toastRef.current?.show({
                        severity: 'info',
                        summary: "",
                        detail: `Configurazioni aggiornate correttamente`,
                        life: 5000
                    })
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: 'Non è stato possibile aggiornare le configurazioni',
                            life: 5000
                        });
                    }
                })
        }

        this.setState({ confirmDialogIsOpen: false, isEnabled: false, changesSaved: true })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    render() {
        return (
            <React.Fragment>
                <Prompt
                    when={this.state.changesMade && !this.state.changesSaved}
                    message={"I cambiamenti non sono stati salvati. Si vuole comunque lasciare la pagina?"}
                ></Prompt>
                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>

                </Dialog>

                <CommandBar
                    overflowButtonProps={overflowProps}
                    items={this.state.commandBarItems}
                    styles={commandBarStyles}
                />

                {this.state.items.length > 0 &&
                    <DetailsList
                        className="with-empty-column"
                        items={this.state.items}
                        styles={detailsListStyles}
                        columns={this.state.columns}
                        onRenderDetailsHeader={this.onRenderDetailsHeader}
                        onRenderRow={this.onRenderItemRow}
                        layoutMode={DetailsListLayoutMode.justified}
                        selectionMode={0}

                    />
                }
                {this.state.items.length === 0 &&

                    <Text block style={{ padding: 25 }}>Nessuna configurazione trovata.</Text>
                }


            </React.Fragment>
        )
    }




}

export default connector(checkRoles(ConfigurationsManager, RoleContext.Aoo));